import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Address } from '../../../../../lib/models/api/address.model';
import { BaseApplicantComponent } from '../base-applicant.component';
import { ApplicantResidence } from './../../../models/applicant-residence.model';
import { MortgageApplicationStore } from './../../../services/mortgage-application-store';

@Component({
  selector: 'boi-applicant-lived-places',
  templateUrl: './applicant-lived-places.component.html',
  styleUrls: ['./applicant-lived-places.component.scss']
})
export class ApplicantLivedPlacesComponent extends BaseApplicantComponent implements OnChanges {
  constructor(protected mortgageApplicationStore: MortgageApplicationStore) {
    super(mortgageApplicationStore);
  }

  private readonly threeYearsInMonths = 36;
  @Input() residences: Array<ApplicantResidence>;

  ngOnChanges(): void {
    if (this.residences) {
      this.residences.sort((a, b) => a.ApplicantResidenceOrder - b.ApplicantResidenceOrder);
    }
  }

  public isResidenceRented(residence: ApplicantResidence): boolean {
    const isRented =
      residence.ResidenceTypeCode === this.referenceDataOptionLists.ResidentialStatusRentPrivatly ||
      residence.ResidenceTypeCode === this.referenceDataOptionLists.ResidentialStatusRentAuthority;

    return (
      this.mortgageApplication &&
      this.mortgageApplication.isResidential &&
      (this.mortgageApplication.IsFullApp || this.mortgageApplication.IsFactFind) &&
      isRented
    );
  }

  public handleResidencesOverThreeYears(): void {
    const applicantResidencesLength = this.residences.length;
    let monthsInTotal = 0;
    let indexOfLastCompletedResidence = -1;
    let indexOfLastValidResidence = -1;

    for (const residence of this.residences) {
      if (
        residence.YearsAtAddress !== undefined &&
        residence.YearsAtAddress !== null &&
        residence.MonthsAtAddress !== undefined &&
        residence.MonthsAtAddress !== null &&
        (residence.MonthsAtAddress > 0 || residence.YearsAtAddress > 0)
      ) {
        indexOfLastCompletedResidence = this.residences.indexOf(residence);
        monthsInTotal += residence.YearsAtAddress * 12 + residence.MonthsAtAddress;
      }

      if (monthsInTotal >= this.threeYearsInMonths) {
        indexOfLastValidResidence = this.residences.indexOf(residence);
        break;
      }
    }

    if (monthsInTotal < this.threeYearsInMonths && indexOfLastCompletedResidence === applicantResidencesLength - 1) {
      const residence = this.instantiateApplicantResidence();
      this.residences.push(residence);
    } else if (indexOfLastValidResidence >= 0) {
      this.residences.splice(indexOfLastValidResidence + 1, applicantResidencesLength);
    }

    if (indexOfLastCompletedResidence < this.residences.length - 2) {
      this.residences.splice(indexOfLastCompletedResidence + 2, applicantResidencesLength);
    }
  }

  private instantiateApplicantResidence(): ApplicantResidence {
    const residence = new ApplicantResidence();
    residence.ResidenceTypeCode = undefined;
    residence.Address = new Address();
    residence.ApplicantResidenceOrder =
      Math.max.apply(
        Math,
        this.residences.map((res) => res.ApplicantResidenceOrder)
      ) + 1;

    return residence;
  }
}
